export const ENDPOINT_LOCK_MOTION_SETTINGS_READ = '/lock/settings/motionget/';
export const ENDPOINT_LOCK_MOTION_SETTINGS_UPDATE = '/lock/settings/motionset/';
